import { Role } from '../../../../../common/constants/role';
import { UserRolesModel } from '../../user';

export class NewsletterType {
  id: number;
  name: string;
  roles: Role[] | UserRolesModel;
  constructor(params?: NewsletterType) {
    Object.assign(this, params);
  }
}
